import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import classes from "./Gallery.module.css";

import React, { useState, useEffect } from "react";

export default function Gallery() {
  const totalGalleryImages = 41;
  const totalGalleryClips = 2;
  const [isItemsLoaded, setIsItemsLoaded] = useState(false);
  const [images, setImages] = useState([]);

  useEffect(() => {
    let imagesARR = [];

    for (let i = 0; i < totalGalleryImages; i++) {
      const currentImgINDX = i + 1;
      imagesARR.push({
        original: `/gallery/${currentImgINDX}.jpg`,
        thumbnail: `/gallery/${currentImgINDX}.jpg`,
      });
    }

    for (let i = 0; i < totalGalleryClips; i++) {
      const currentClipINDX = i + 1;
      imagesARR.push({
        original: `/gallery/Videos/clip${currentClipINDX}.mp4`,
        thumbnail: `/gallery/Videos/clip${currentClipINDX}IMG.png`,
        renderItem: () => (
          <div>
            <video controls>
              <source
                src={`/gallery/Videos/clip${currentClipINDX}.mp4`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        ),
      });
    }
    // {
    //   original: 'path/to/video1.mp4',
    //   thumbnail: 'path/to/video-thumbnail.jpg', // תמונת thumbnail של הסרטון
    //   description: 'Video 1 description',
    //   renderItem: () => (
    //     <div>
    //       <video controls>
    //         <source src="path/to/video1.mp4" type="video/mp4" />
    //         Your browser does not support the video tag.
    //       </video>
    //     </div>
    //   )
    // }

    setImages([...imagesARR]);
    setIsItemsLoaded(true);
  }, []);

  return (
    <div className={classes.galleryWidth}>
      {isItemsLoaded && <ImageGallery items={images} isRTL={true} />}
    </div>
  );
}
